import React from "react";
import FeaturedProductsHeading from "@widgets/featuredProducts/overview/heading/FeaturedProductsHeading";
import {Route} from "@/routing/Router";
import FeaturedProductsTable from "@widgets/featuredProducts/overview/table/FeaturedProductsTable";

type Props = {
    route: Route,
};

const FeaturedProductsOverview = ({route}: Props) => {
    return (
        <>
            <FeaturedProductsHeading route={route}/>

            <div className={"mt-6 md:mt-12"}>
                <FeaturedProductsTable/>
            </div>
        </>
    );
};

export default FeaturedProductsOverview;